export const SecurityContext = {
	Host: "web_Host",
	Menu: "portal_Menu",
	RestrictByAssociation: "restrictByAssociation"
} as const;

export const SecurityContextPermission = {
	False: "false"
} as const;
